export const BEZUGSRECHT_ROUTES = {
  HOME: '',
  BUY: 'kaufen',
  SELL: 'verkaufen',
  BUY_CUSTOM: 'kaufen-mit-anpassung',
  SUMMARY: 'zusammenfassung',
  SUCCESS: 'erfolgreich',
};

export const TEILRECHT_ROUTES = {
  HOME: '',
  SUMMARY: 'zusammenfassung',
  SUCCESS: 'erfolgreich',
};

export const WAHLDIVIDENDE_ROUTES = {
  HOME: '',
  SUCCESS: 'erfolgreich',
};
